import React from "react";
import styled from "styled-components";
import { ITheme } from "../Themes/ThemeTypes";
import { ThemeColorEnum, ThemeIconEnum, ThemeIconSizeEnum } from "../Themes/ThemeEnums";
import Icon from "../Icon/Icon";
import FontText from "../FontText/FontText";
import { FontSizeEnum, FontTypeEnum } from "../FontText/FontTextEnums";
import { FilledButton } from "../Button";
import type { RetryAction } from "./ErrorStateTypes";

const Wrapper = styled.div<{ theme: ITheme }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 48px 16px;
`;

interface ErrorStateProps {
  icon?: ThemeIconEnum;
  headline: string;
  supporting?: string;
  retry?: RetryAction;
}

const ErrorState: React.FC<ErrorStateProps> = ({
  icon = ThemeIconEnum.CLOUD_OFF,
  headline,
  supporting,
  retry,
}) => (
  <Wrapper>
    <Icon icon={icon} color={ThemeColorEnum.ERROR} size={ThemeIconSizeEnum.EXTRA_EXTRA_LARGE} />
    <FontText
      text={headline}
      $color={ThemeColorEnum.ON_SURFACE}
      $fontType={FontTypeEnum.TITLE}
      $fontSize={FontSizeEnum.MEDIUM}
    />
    {supporting && (
      <FontText
        text={supporting}
        $color={ThemeColorEnum.ON_SURFACE_VARIANT}
        $fontType={FontTypeEnum.BODY}
        $fontSize={FontSizeEnum.MEDIUM}
      />
    )}
    {retry && <FilledButton label={retry.label} onClick={retry.onClick} />}
  </Wrapper>
);

export default ErrorState;
